module.exports = __webpack_public_path__ + "static/media/phone_icon.efc6dd8f.png";